
          var style;
          try {
            style = require("./icon-maker.css");
          } catch(e) {
            if (e.code !== 'MODULE_NOT_FOUND') throw e;
          }
          module.exports = style;


//////////////////
// WEBPACK FOOTER
// ./~/icon-maker-loader/.tmp/0f34c3a4-6dce-4c65-b92a-b34bc52b73d4/icon-maker.js
// module id = 17
// module chunks = 5